import type { IContent } from '@next-space/fe-inlined';
import { getEditorModelByEditorKey } from 'src/editor/editor/uikit/editable-models';
import { convertContentToSegments } from 'src/editor/utils/segments';
import { addBlock } from 'src/redux/managers/block/add';
import { cache } from 'src/redux/store';
import type { NextWhere } from 'src/redux/types';
import { isCollection } from 'src/utils/block-type-utils';
import { idsToSelectedBlocks } from 'src/utils/select-block-util';
import type { PasteHook } from '../types';
import { common } from './common';

export const pasteContent = (
  { transaction, selectedBlockHistory }: PasteHook,
  content: IContent
) => {
  const { pageId, pos, selectedBlocks, posEditorKey, syncId, viewId } = common();
  // 选中并且非focus或者没选中才会创建新的块
  if ((selectedBlocks.length && !pos) || !pos) {
    if (isCollection(cache.blocks[pageId]?.type)) return;
    transaction(() => {
      const where: NextWhere = { parentId: pageId };
      if (selectedBlocks.length) {
        where.after = selectedBlocks[selectedBlocks.length - 1]?.blockId;
      }
      const segments = convertContentToSegments(content);
      const id = addBlock({ data: { segments } }, where);
      selectedBlockHistory?.(idsToSelectedBlocks(id, viewId, syncId), selectedBlocks);
    });
  }

  if (pos && posEditorKey) {
    const editorModel = getEditorModelByEditorKey(posEditorKey);
    if (editorModel) {
      editorModel.performChange((ctx) => {
        if (ctx.selection) {
          ctx.delete();
        }
        ctx.insert(content);
      });
    }
  }
};
